import * as HttpService from './http.service';
import * as URL from './url.service';
import { getTimeLineData } from 'services/timeline.service';
import { getTotalHrs } from 'helper/demandDataMaker';
import { setDecimalPrecision } from 'helper/util';


export const createAllocation = (data) => HttpService.postWithAuth(URL.CREATE_ALLOCATION_URL, data);

export const getAllocationShiftTimingsByAllocationId = ({ allocationId }) => HttpService.getWithAuth(URL.GET_ALLOCATION_SHIFT_TIMINGS_BY_ALLOCATION_ID({ allocationId }));

export const createAllocationShiftTimings = (data) => HttpService.postWithAuth(URL.CREATE_ALLOCATION_SHIFT_TIMINGS_URL, data);

export const getAllocatedResources = (demandId, offset, limit, order, orderBy, todaysDate) => HttpService.getWithAuth(URL.GET_ALLOCATED_RESOURCES_URL(demandId, offset, limit, order, orderBy, todaysDate));

export const updateAllocation = (allocationId, data) => HttpService.putWithAuth(URL.UNALLOCATION_URL(allocationId), data);
export const getAllAllocations = (offset, limit, order, orderBy, todaysDate) => HttpService.getWithAuth(URL.GET_ALL_ALLOCATION_URL2(offset, limit, order, orderBy, todaysDate));

export const getAllAllocationsFilter = (offset, limit, order, orderBy, todaysDate, search, filters, sort, projectId, draft) => HttpService.getWithAuth(URL.GET_ALL_ALLOCATION_URL(offset, limit, order, orderBy, todaysDate, search, filters, sort, projectId, draft ));
export const getRejectedAllocations = (
    offset,
    limit,
    search,
    filters
) => HttpService.getWithAuth(
    URL.GET_REJECTED_ALLOCATION_URL(offset, limit, search, filters)
);
export const getRejectedAllocationsCsv = (
    search,
    filters
) => HttpService.getWithAuth(
    URL.GET_REJECTED_ALLOCATION_CSV_URL( search, filters)
);


export const updateAllocations = (updateData, idArray) => HttpService.putWithAuth(URL.UPDATE_ALLOCATIONS_URL, { updateData, idArray });
export const editTenure = (allocationId, {
    startDate, endDate, weeklyHours, includeSaturday, includeSunday, adjustedUtilizations, isContinuityResource, continuityReason, continuityReasonComment, isBudgetExceed, allocationShiftTimings, wbsL4Code
}) => HttpService.putWithAuth(URL.EDIT_ALLOCATION_TENURE_URL(allocationId), {
    startDate,
    endDate,
    weeklyHours,
    includeSaturday,
    includeSunday,
    adjustedUtilizations,
    isContinuityResource, continuityReason, continuityReasonComment,
    isBudgetExceed,
    allocationShiftTimings,
    wbsL4Code
});

export const getAllocationByResourceId = (resourceId, startDate, endDate) => HttpService.getWithAuth(URL.GET_ALLOCATION_BY_RESOURCE_ID_URL(resourceId, startDate, endDate));

export const bulkUnAllocation = (unallocateReason, resourceData) => HttpService.putWithAuth(URL.BULK_UN_ALLOCATION_URL, {
    unallocateReason,
    resourceData
});

export const createResolveAllocation = (data) => HttpService.postWithAuth(URL.CREATE_RESOLVE_ALLOCATION_URL, data);
export const getABVDAllocationConflictStatus = (data) => HttpService.postWithAuth(URL.GET_ABVD_ALLOCATION_CONFLICT_STATUS(), data)
export const checkAllocationConflict = (data) => HttpService.postWithAuth(URL.CHECK_ALLOCATION_CONFLICT_URL, data);
export const checkAllocationBudgetConflict = (data) => HttpService.postWithAuth(URL.CHECK_ALLOCATION_BUDGET_CONFLICT_URL, data);

export const createResolveForceAllocation = (data) => HttpService.postWithAuth(URL.CREATE_RESOLVE_FORCE_ALLOCATION_URL, data);
export const createSelfAllocation = (data) => HttpService.postWithAuth(URL.CREATE_SELF_ALLOCATION_URL, data);
export const updateSelfAllocation = (allocationId, data) => HttpService.putWithAuth(URL.UPDATE_SELF_ALLOCATION_URL(allocationId), data);
export const createAllocationV2 = (data) => HttpService.postWithAuth(URL.CREATE_ALLOCATION_V2_URL, data);

export const getAllocationCsv = (
    offset,
    limit,
    order,
    orderBy,
    todaysDate,
    search,
    filters,
    sort,
    exportType
) => HttpService.getWithAuth(URL.GET_ALLOCATION_CSV_URL(offset, limit, order, orderBy, todaysDate, search, filters, sort, exportType));

export const getTotalHoursForAllocateMeAnyway = (startDate, endDate, hoursPerWeek) => {
    let { totalHours } = getTotalHrs(
        startDate,
        endDate,
        setDecimalPrecision(hoursPerWeek)
    );
    const timeline = getTimeLineData({
        demandStartDate: startDate,
        demandEndDate: endDate,
        existingTimeLines: [],
        totalhours: totalHours,
        hoursPerWeek: parseInt(hoursPerWeek)
    });
    totalHours = timeline.reduce((acc, tl) => (((tl.hours || tl.hoursPerMonth) || 0) + acc), 0);
    return totalHours;
}

export const getWorkingHoursPerDay = ({ isArticleGrade = false, isSpecialProject = false, isTNTFunction = false } = {}) => {
    let workHours = Number(process.env.NEXT_PUBLIC_WORK_HOURS_PER_DAY) || 8;
    if(isTNTFunction) {
        workHours = Number(process.env.NEXT_PUBLIC_WORK_HOURS_PER_DAY_FOR_SPECIAL_PROJECTS) || 9;
    }
    if (isArticleGrade) {
        workHours = Number(process.env.NEXT_PUBLIC_WORK_HOURS_PER_DAY_FOR_ARTICLE) || 7;
    }
    if (isSpecialProject) {
        workHours = Number(process.env.NEXT_PUBLIC_WORK_HOURS_PER_DAY_FOR_SPECIAL_PROJECTS) || 9;
    }
    return workHours;
};

export const getWorkingHoursPerWeek = ({ includeSunday = false, includeSaturday = false, isArticleGrade = false, isSpecialProject = false, isTNTFunction = false } = {}) => {
    let numberOfWorkingDay = 5;
    if (includeSunday) {
        numberOfWorkingDay += 1;
    }
    if (includeSaturday) {
        numberOfWorkingDay += 1;
    }
    const workHoursPerWeek = getWorkingHoursPerDay({ isArticleGrade, isSpecialProject, isTNTFunction }) * numberOfWorkingDay;

    return workHoursPerWeek;
};

export const getMaxWorkingHoursPerWeek = ({ includeSunday = false, includeSaturday = false } = {}) => {
    let numberOfWorkingDay = 5;
    if (includeSunday) {
        numberOfWorkingDay += 1;
    }
    if (includeSaturday) {
        numberOfWorkingDay += 1;
    }
    const maxWorkHoursPerWeek = 24 * numberOfWorkingDay;

    return maxWorkHoursPerWeek;
};

export const validateBudgetConflictAndShowAlert = async ({
    demandId,
    projectId,
    resources, setShowAlert, alertType = 'allocate-budget-exceeded-alert'
}) => {
    if (Array.isArray(resources) && resources.length) {
        const [{
            startDate,
            endDate,
            hoursPerWeek,
            includeSaturday,
            includeSunday,
            resourceName: { value: resourceId },
            id: allocationId,
        }] = resources;

        const budgetConflictCheck = await checkAllocationBudgetConflict({
            startDate,
            endDate,
            weeklyHours: hoursPerWeek,
            demandId,
            projectId,
            resourceId,
            allocationId,
            includeSaturday,
            includeSunday
        })

        if (budgetConflictCheck.status && budgetConflictCheck.entity.budgetExceeding) {
            setShowAlert(alertType);
            return { budgetExceeding: budgetConflictCheck.entity.budgetExceeding }
        }
    }

    return { budgetExceeding: false }
}

export const getWbsL4CodeStatusForAllocation = (demandId, startDate, endDate) => HttpService.getWithAuth(URL.GET_SWIFT_WBS_L4_CODE_STATUS_FOR_ALLOCATION(demandId, startDate, endDate));
export const getAllocationUnderProjectCSV = async ({ projectId, search = null, filters = null, sort = null }) => {
    return HttpService.getWithAuth(URL.GET_ALLOCAITON_UNDER_PROJECT_CSV({ projectId, search, filters, sort }));
}   
